'use strict';

var React = require('react');

var SvgDisputeMinor = function SvgDisputeMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 9a1 1 0 0 0 2 0v-2a1 1 0 1 0-2 0v2zm0 4a1 1 0 1 0 2 0 1 1 0 0 0-2 0zm-7-3c0 4.411 3.589 8 8 8a7.939 7.939 0 0 0 4.111-1.15l2.494 1.069a1 1 0 0 0 1.314-1.313l-1.069-2.495a7.939 7.939 0 0 0 1.15-4.111c0-4.411-3.589-8-8-8s-8 3.589-8 8z"
  }));
};

exports.SvgDisputeMinor = SvgDisputeMinor;
